import React from 'react';
import { BookOpen, ArrowLeft, ExternalLink, ShieldCheck, Award, Layers } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { isManagementOrTrainer } from '../../utils/formatters';
import { PageHeader } from '../../components/common/PageHeader';
import { DashboardSyllabusManager } from '../../components/syllabus/DashboardSyllabusManager';
import { navigateBack } from '../../utils/scrollRestoration';

export const PengurusanSilibusPage: React.FC = () => {
  const { currentUser } = useAuth();
  const isManagement = Boolean(currentUser && isManagementOrTrainer(currentUser));

  const navigateTo = (path: string) => {
    window.history.pushState(null, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  if (!isManagement) {
    return (
      <div className="w-full bg-white rounded-3xl border border-slate-200 p-8 sm:p-12 text-center space-y-4 shadow-sm animate-fade-in">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-red-50 text-asmm-red flex items-center justify-center border border-red-100 shadow-2xs">
          <ShieldCheck className="w-7 h-7" />
        </div>
        <div className="max-w-md mx-auto space-y-1.5">
          <h3 className="text-base sm:text-lg font-extrabold text-slate-900">
            Akses Pengurusan Silibus Terhad
          </h3>
          <p className="text-xs text-slate-500 leading-relaxed">
            Halaman Pengurusan Kurikulum &amp; Silibus hanya boleh diakses oleh pihak pentadbir persatuan, Ketua Gelanggang, dan barisan Jurulatih bertauliah ASMM.
          </p>
        </div>
        <div>
          <button
            type="button"
            onClick={() => navigateBack('/syllabus')}
            className="px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold rounded-xl transition-all cursor-pointer border-none shadow-sm inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Kembali ke Pengajian Silibus</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full space-y-6 min-h-[75vh] animate-fade-in">
      {/* Page Header */}
      <PageHeader
        badgeText="Pengurusan Kurikulum"
        badgeIcon={BookOpen}
        title="Pengurusan Kurikulum & Silibus"
        titleBadge="Pentadbir & Jurulatih"
      >
        <div className="flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={() => navigateTo('/silibus-awam')}
            className="px-3.5 py-2 bg-white hover:bg-slate-50 text-slate-700 text-xs font-bold rounded-xl transition-all flex items-center gap-1.5 cursor-pointer border border-slate-200 shadow-2xs"
            title="Buka paparan silibus awam berdaftar e-ROS"
          >
            <ExternalLink className="w-3.5 h-3.5 text-blue-600" />
            <span>Lihat Silibus Awam</span>
          </button>

          <button
            type="button"
            onClick={() => navigateBack('/syllabus')}
            className="px-3.5 py-2 bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold rounded-xl transition-all flex items-center gap-1.5 cursor-pointer shadow-xs"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            <span>Kembali ke Silibus Ahli</span>
          </button>
        </div>
      </PageHeader>

      {/* Reassurance & Guidelines Banner */}
      <div className="bg-gradient-to-r from-red-50/70 via-white to-amber-50/50 p-4 sm:p-5 rounded-3xl border border-red-100/80 shadow-2xs flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-start sm:items-center gap-3">
          <div className="p-2.5 bg-white text-asmm-red rounded-2xl border border-red-100 shadow-xs shrink-0">
            <Layers className="w-5 h-5" />
          </div>
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <h4 className="text-xs sm:text-sm font-black text-slate-900">
                Piawaian Kurikulum Perguruan ASMM (PPM-007-02-28082022)
              </h4>
              <span className="text-[10px] font-extrabold bg-red-100 text-asmm-red px-2 py-0.5 rounded-full">
                e-ROS Bertauliah
              </span>
            </div>
            <p className="text-[11px] sm:text-xs text-slate-600 mt-0.5">
              Uruskan bab pembelajaran, sukatan video YouTube/Drive, panduan fail PDF, dan prasyarat bengkung bagi setiap peringkat silibus silat.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-white rounded-xl border border-slate-200/90 text-[11px] font-bold text-slate-700 shadow-2xs">
            <Award className="w-3.5 h-3.5 text-amber-500" />
            <span>Kenaikan Bengkung Rasmi</span>
          </div>
        </div>
      </div>

      {/* Main Syllabus Manager Component */}
      <DashboardSyllabusManager />
    </div>
  );
};
